module.exports = __webpack_public_path__ + "static/media/BentoGoncalves.8751d9c5.jpg";